<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left col-4">
        {{ $t('sidebar.payslip') }} > {{ $t('sidebar.all') }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div class="action">
          <BaseFilterDocProcessStatus
            :docType="`prl`"
            :status="query.status"
            @onSelect="handleSelectStatus"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <base-table
        :pagination="pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 110px;">{{ $t('series.prl') }}</th>
              <th style="min-width: 110px;">{{ $t('series.pe') }}</th>
              <th>{{ $t('message.debttotal') }}</th>
              <th>{{ $t('message.paidtotal') }}</th>
              <th>{{ $t('apps.payroll.message.grandtotal') }}</th>
              <th style="max-width: 100px;">{{ $t('apps.payroll.message.employeelistcount') }}</th>
              <th style="max-width: 100px;">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="empty"
                colspan="7"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in data"
              :key="index"
            >
              <td>
                <router-link
                  :to="{
                    name: 'PaySlipEdit',
                    query: {
                      id: item.prlId,
                      code: item.prlCode,
                    }
                }">
                  {{ item.prlCode }}
                </router-link>
              </td>
              <td style="vertical-align: top;">
                <div
                  v-for="(payment, index) in item.payments"
                  :key="index">
                  <router-link-custom
                    :to="{ name: 'AccountsPaymentEntryEdit', query: { pe_id: payment.peId, pe_code: payment.peCode }}"
                    :text="payment.peCode"
                    :status="{
                      text: getPaymentStatus(payment, $t).message,
                      color: getColorFormStatus(getPaymentStatus(payment, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="12"
                    :current_appid="14"
                  />
                </div>
              </td>
              <td>
                {{
                  item.status === 'approved' ?
                    getNumber(item.process.debit) :
                    getNumber(0)
                }}
              </td>
              <td>
                {{
                  item.status === 'approved' ?
                    getNumber(item.net - item.process.debit) :
                    getNumber(0)
                }}
              </td>
              <td>
                {{ getNumber(item.net) }}
              </td>
              <td>
                {{ numberel(item.appliedCount) }}
              </td>
              <td>
                <BaseDocumentProcessStatus
                  :docType="`prl`"
                  :status="item.process.status"
                />
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import tablePaginateMixin from '@/mixins/tablePaginate'
import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [tablePaginateMixin, userPermissionMixin],

  data () {
    return {
      loading: true,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || null,
      },
    }
  },

  computed: {
    ...mapState('payroll', {
      data: 'paySlipList',
    }),
    ...mapGetters({
      getPaymentStatus: 'getPaymentStatus',
    }),
  },

  watch: {
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = null
        this.fetchData()
      }
    },
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 1,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('payroll', {
      getPaySlipList: 'getPaySlipList',
    }),
    async fetchData () {
      this.updateUrl()
      this.loading = true
      await this.getPaySlipList({
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        ...(() => {
          if (this.query.status) {
            return {
              status: this.query.status,
            }
            return null
          }
        })(),
      })
      this.loading = false
      this.showFinish(this.$Progress)
    },
    handleSelectStatus (status = null) {
      this.query.page = 1
      this.query.status = status
      this.fetchData()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/payslip/List.vue